<template>
  <div class="right">
    <div class="bordered padding-30 rounded news-list" style="margin-bottom: 20px;">
      <div class="column-title">{{ $t('index.headline-news') }}</div>
      <div style="flex-direction: column; gap: 10px;">
        <div 
          v-for="(item, index) in headlineList" 
          :key="index" 
          class="list" 
          @click="article(item.id)" 
          style="cursor: pointer;"
        >
          <i class="el-icon-s-promotion" style="color: #f00; margin-right: 10px;"></i>
          <div class="column-1">{{ applicationLocale === 'en' ? item.title_en : item.title }}</div>
        </div>
      </div>
    </div>
    <div class="bordered padding-30 rounded news-list" style="margin-bottom: 20px;">
      <div class="column-title">{{ $t('index.recommend') }}</div>
      <div style="flex-direction: column;">
        <div 
          v-for="(item, index) in data" 
          :key="index" 
          class="recommend" 
          @click="article(item.id)" 
          style="cursor: pointer;"
        >
          <div class="image">
            <img :src="item.image_url" />
          </div>
          <div class="text">
            <div class="column-2">{{ applicationLocale === 'en' ? item.title_en : item.title }}</div>
            <div class="date">{{ item.created_at }}</div>
          </div>
        </div>
      </div>
    </div>
    <img 
      v-for="(item, index) in adList" 
      :key="index" 
      :src="item.image_url" 
      v-if="(page === 'index' ? index > 0 : true) && item.type == 1" 
      style="width: 100%; margin-bottom: 10px;" 
      @click="nav(item.url)"
    />
  </div>
</template>

<script>
import api from '@/api/'
import storage from '@/utils/storage'
import { Message, MessageBox } from 'element-ui'

export default {
  name: 'Recommend',
  props: {
    applicationLocale: {
      type: String,
      default: ''
    },
    config: {
      type: Object,
      default: () => ({})
    },
    adList: {
      type: Array,
      default: () => []
    },
    headlineList: {
      type: Array,
      default: () => []
    },
    page: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      data: []
    }
  },
  mounted() {
    if (!storage.getItem('openArticleList')) {
      this.getOpenArticleList()
    } else {
      this.data = storage.getItem('openArticleList') || []
    }
  },
  methods: {
    handleImageError(item) {
      // 处理图片显示错误
    },
    article(id) {
      this.$router.push({ path: '/pages/news/article', query: { id } }).catch(err => {
        if (err.name !== 'NavigationDuplicated') console.error(err)
      })
    },
    getOpenArticleList() {
      api.getData('index/openArticleList')
        .then((res) => {
          storage.setItem('openArticleList', res.data.data)
          this.data = res.data.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    download(platform) {
      if (platform === 'Android') {
        Message.info('下载中')
        location.href = 'https://pp.bet-info.net/apps/betinfo.apk'
      } else {
        MessageBox.alert(platform + ' ' + this.$t('index.app-development'), platform, {
          confirmButtonText: '关闭'
        })
      }
    },
    nav(url) {
      window.location.href = url
    }
  }
}
</script>

<style>
@import '../../public/static/css/index.css';
</style>
